import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddInteractionComponent } from './add-interaction/add-interaction.component';
import { AllInteractionsComponent } from './all-interactions/all-interactions.component';
import { EditInteractionComponent } from './edit-interaction/edit-interaction.component';


const routes: Routes = [
  {
    path: '',
    component: AllInteractionsComponent
  },
  {
    path: 'new',
    component: AddInteractionComponent
  },
  {
    path: ':id',
    component: EditInteractionComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InteractionsRoutingModule { }
